import * as React from 'react';
import { IconActionClose16, IconProductTrust16 } from '@cian/ui-kit-design-tokens/icons';
import { clsx } from 'clsx';
import * as styles from './NewBuildingCard.css';

interface INewBuildingCardProps {
  hasClose?: boolean;
  isReliable: boolean;
  url: string;
  image: React.ReactNode;
  title: React.ReactNode;
  promo: React.ReactNode;
  labels?: React.ReactNode;
  finishLabel: React.ReactNode;
  subwayInfo: React.ReactNode;
  address: React.ReactNode;
  apartmentsInSearch?: React.ReactNode;
  apartments?: React.ReactNode;
  showPhone?: React.ReactNode;
  size?: 'XS' | 'M';
  onTitleClick?(): void;
  onApartmentsClick?(): void;
  onImageClick?(): void;
}

export function NewBuildingCard({
  image,
  isReliable,
  url,
  hasClose = false,
  title,
  promo,
  labels,
  finishLabel,
  subwayInfo,
  address,
  apartments,
  apartmentsInSearch,
  size = 'M',
  onTitleClick,
  onApartmentsClick,
  onImageClick,
  showPhone,
}: INewBuildingCardProps) {
  return (
    <article className={clsx(styles['card'], { [styles['card--xs']]: size === 'XS' })}>
      {promo && <div className={styles['card__promo']}>{promo}</div>}

      {hasClose && (
        <span id="close" className={styles['card__close']}>
          <IconActionClose16 color="icon-inverted-default" />
        </span>
      )}

      <a href={url} target="_blank" rel="noopener noreferrer" className={styles['card__image']} onClick={onImageClick}>
        {image}
      </a>

      <div className={styles['card__body']}>
        <div className={styles['card__labels']}>{labels}</div>
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className={styles['card__title']}
          onClick={onTitleClick}
        >
          {title}

          {isReliable && (
            <span className={styles['card__reliable']}>
              <IconProductTrust16 color="icon-main-default" />
            </span>
          )}
        </a>

        <div className={styles['card__body-item']}>{finishLabel}</div>
        <div className={styles['card__body-item']}>{subwayInfo}</div>
        <div className={styles['card__body-item']}>{address}</div>

        {apartmentsInSearch && <div className={styles['card__apartments-search']}>{apartmentsInSearch}</div>}

        {showPhone && <div className={styles['phone']}>{showPhone}</div>}

        {apartments && (
          <div className={styles['card__apartments']} onClick={onApartmentsClick}>
            {apartments}
          </div>
        )}
      </div>
    </article>
  );
}
